module.exports = __webpack_public_path__ + "img/facepaint-mobile.4f126cf.jpg";